<template>
  <div>
    <v-card
      style="margin: 10px 0px 10px 0px;border: 2px solid rgba(0,0,0,0.2);"
    >
      <v-toolbar
        :color="hidden ? 'default' : 'transparent'"
        flat
        dense
      >
        <div
          v-if="hidden"
        >
          <b>{{fieldType.subfieldtypes[0].text}}: </b>{{firstAnswer}}
        </div>
        <v-spacer />
        <v-btn
          @click="hidden=!hidden"
          small
          flat
          color="grey"
        >
          {{hidden ? 'Show List Item' : 'Hide List Item'}}
        </v-btn>
      </v-toolbar>
      <v-card-text
        @mouseover="hovering = true"
        @mouseleave="hovering = false"
        style="position:relative;"
        :style="hidden ? 'position:relative;display:none;' : 'position:relative;'"
      >
        <div
          v-for="subfieldtype in fieldType.subfieldtypes"
          :key="subfieldtype.id"
        >
          <span style="font-weight:900;">{{subfieldtype.text}}</span>
          <v-icon
            v-if="subfieldtype.required"
            size="10"
            color="red"
            style="vertical-align:middle;padding-left: 10px;"
          >
            mdi-asterisk
          </v-icon>
          <AnswerField
            :userFormId="userFormId"
            :question="question"
            :fieldType="subfieldtype"
            :listId="listId"
            :isEmpty="isEmpty"
            :readOnly="deleting"
            @update:listId="$emit('update:listId', arguments[0])"
          />
        </div>
        <v-btn
          v-if="hovering"
          style="position:absolute;right:-25px;top:-25px;"
          fab
          color="red"
          @click="doDelete"
        >
          <v-icon color="white">delete</v-icon>
        </v-btn>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="deleteDialog"
      width="400"
      persistent
    >
      <v-card
        style="background: #F44336; color: white;"
      >
        <v-card-text
          style="text-align:center"
        >
          <v-icon
            color="white"
            size="92"
          >
            mdi-delete-empty
          </v-icon><br />
          Are you sure you want to delete this row? The answers in this row will be deleted.
        </v-card-text>
        <v-card-actions>
          <v-btn
            dark
            small
            flat
            @click="doDelete"
          >
            Delete
          </v-btn>
          <v-spacer />
          <v-btn
            color="white"
            @click="deleteDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AnswerField from './AnswerField'
import answerListMixin from '@/components/global/answerlistmixin'
import { mapGetters } from 'vuex'

export default {
  name: 'AnswerListItem',
  props: [ 'userFormId', 'question', 'fieldType', 'listId' ],
  mixins: [ answerListMixin ],
  data () {
    return {
      hidden: false,
    }
  },
  components: {
    AnswerField
  },
  computed: {
    ...mapGetters('userform', {
      answerObject: 'answer'
    }),
    firstAnswer () {
      var answerObj = this.answerObject(this.question.id, this.fieldType.subfieldtypes[0].id, this.listId ? this.listId.id : null) || {}
      return answerObj['string']
    }
  }
}
</script>

<style scoped>
  td {
    vertical-align: bottom;
    padding-right: 4px;
    border-bottom: rgba(0,0,0,0.2) 1px solid;
  }
</style>
